import MaintenancePage from './Maintenance.page';

export default MaintenancePage;
